import {Frontend} from "./frontend";

(function () {
    XonBoard.Assets = {
        import: function (url) {
            XonBoard.Utils.importFileUsingButton(url);
        },
        list: {

            selectors: {
                assets_table: $('#assets-table'),
                count_label: $('#count-label'),
            },

            initFuel: function () {
                var columns = [
                    {data: 'serial_number', name: 'assets.serial_number', searchable: false,},
                    {data: 'site_name', name: 'sites.name', searchable: false,},
                    {data: 'name', name: 'assets.name'},
                    {data: 'device_eui', name: 'sensors.device_eui', searchable: true, sortable: false},
                    {data: 'description', name: 'assets.description'},
                    {data: 'asset_type_name', name: 'asset_types.name', searchable: false,},
                    {data: 'fuel_level', name: 'assets.fuel_level', searchable: false, sortable: false},
                    {
                        data: 'volume',
                        name: 'assets.config->volume',
                        searchable: false,
                    },
                    {
                        data: 'ullage',
                        name: 'assets.ullage',
                        searchable: false,
                        sortable: false,
                    },
                    {data: 'to_fill', name: 'assets.to_fill', sortable: false, searchable: false},
                    {data: 'actions', name: 'actions', searchable: false, sortable: false}
                ];

                this.initTable(columns);
            },
            initFuelQuality: function () {
                var columns = [
                    {data: 'serial_number', name: 'assets.serial_number', searchable: false,},
                    {data: 'site_name', name: 'sites.name', searchable: false,},
                    {data: 'name', name: 'assets.name'},
                    {data: 'device_eui', name: 'sensors.device_eui', searchable: true, sortable: false},
                    {data: 'description', name: 'assets.description'},
                    {data: 'asset_type_name', name: 'asset_types.name', searchable: false, sortable: false},
                    {data: 'liquid_density', name: 'assets.liquid_density', searchable: false, sortable: false},
                    {data: 'temperature', name: 'assets.temperature', searchable: false, sortable: false},
                    {data: 'actions', name: 'actions', searchable: false, sortable: false}
                ];

                this.initTable(columns);
            },

            initGenerator: function () {
                var columns = [
                    {data: 'serial_number', name: 'assets.serial_number', searchable: false,},
                    {data: 'site_name', name: 'sites.name', searchable: false,},
                    {data: 'name', name: 'assets.name'},
                    {data: 'device_eui', name: 'sensors.device_eui', searchable: true, sortable: false},
                    {data: 'description', name: 'assets.description'},
                    {data: 'asset_type_name', name: 'asset_types.name', searchable: false,},
                    {data: 'current1', name: 'assets.current1', searchable: false, sortable: false},
                    {data: 'current2',name: 'assets.current2',searchable: false, sortable: false},
                    {data: 'current3',name: 'assets.current3',searchable: false, sortable: false},
                    {data: 'actions', name: 'actions', searchable: false, sortable: false}
                ];

                this.initTable(columns);
            },

            initCircuitBreaker: function () {
                var columns = [
                    {data: 'serial_number', name: 'assets.serial_number', searchable: false,},
                    {data: 'site_name', name: 'sites.name', searchable: false,},
                    {data: 'name', name: 'assets.name'},
                    {data: 'device_eui', name: 'sensors.device_eui', searchable: true, sortable: false},
                    {data: 'description', name: 'assets.description'},
                    {data: 'asset_type_name', name: 'asset_types.name', searchable: false,},
                    {data: 'actions', name: 'actions', searchable: false, sortable: false}
                ];

                this.initTable(columns);
            },

            init: function () {
                var columns = [
                    {data: 'serial_number', name: 'assets.serial_number', searchable: false,},
                    {data: 'site_name', name: 'sites.name', searchable: false,},
                    {data: 'name', name: 'assets.name'},
                    {data: 'device_eui', name: 'sensors.device_eui', searchable: true, sortable: false},
                    {data: 'description', name: 'assets.description'},
                    {data: 'asset_type_name', name: 'asset_types.name', searchable: false,},
                    {data: 'actions', name: 'actions', searchable: false, sortable: false}
                ];

                this.initTable(columns);
            },

            initTemperature: function () {
                var columns = [
                    {data: 'serial_number', name: 'assets.serial_number', searchable: false,},
                    {data: 'site_name', name: 'sites.name', searchable: false,},
                    {data: 'name', name: 'assets.name'},
                    {data: 'device_eui', name: 'sensors.device_eui', searchable: true, sortable: false},
                    {data: 'description', name: 'assets.description'},
                    {data: 'asset_type_name', name: 'asset_types.name', searchable: false,},
                    {data: 'temperature', name: 'assets.temperature', searchable: false,},
                    {
                        data: 'min_temperature_threshold',
                        name: 'assets.min_temperature_threshold',
                        searchable: false,
                    },
                    {
                        data: 'max_temperature_threshold',
                        name: 'assets.max_temperature_threshold',
                        searchable: false,
                    },
                    {data: 'critical_time', name: 'assets.critical_time', sortable: false, searchable: false},
                    {data: 'actions', name: 'actions', searchable: false, sortable: false}
                ];

                this.initTable(columns);
            },

            initTable(columns) {
                let self = this;

                let table = this.selectors.assets_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.assets_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data: Frontend.DataTableSearch.globalFilter,
                    },
                    columns: columns,
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                const onCreatedSuccessfully = function (data) {
                    if (data.edit_config_url) {
                        XonBoard.Utils.EditByUrl(data.edit_config_url);
                    }
                };

                Frontend.DataTable.init(table, onCreatedSuccessfully);
                Frontend.DataTableSearch.init(table);
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
        create: function (button) {
            $.ajax({
                url: $(button).data('url'),
                type: "GET",
                dataType: 'html',
                success: function (data) {
                    $('body').prepend(data);
                    XonBoard.Utils.Select2.init();
                    var createAssetModal = $('#create-asset-modal');
                    createAssetModal.modal('toggle');

                    $('#cancel').click(function () {
                        $('#create-asset-modal').modal('hide');
                        createAssetModal.modal('hide')
                        createAssetModal.on('hidden.bs.modal', function (e) {
                            createAssetModal.remove()
                        })
                    });

                    $("#create-form").submit(function (e) {
                        e.preventDefault();
                        $("#create-form").ajaxSubmit({
                            success: function (data) {
                                if (data.edit_config_url) {
                                    XonBoard.Utils.EditByUrl(data.edit_config_url);
                                }

                                XonBoard.Utils.handleSuccess(data.flash_success);

                                createAssetModal.modal('hide')
                                createAssetModal.on('hidden.bs.modal', function (e) {
                                    createAssetModal.remove()
                                })
                            },
                            error: function (xhr, status, data) {
                                XonBoard.Utils.handleError(xhr, data)
                                $("#update").removeAttr("disabled");
                            }
                        });
                    });
                }
            });
        },
    }
})();
